"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorSchemes = void 0;
exports.colorSchemes = ["auto", "light", "dark"];
